
import { defineComponent, ref, Ref } from 'vue'
import useClickOutside from '@/composables/clickOutside/clickOutside'
import AButton from '@/components/Forms/AButton.vue'
import usePostListMenu, {
  ActivePostPage,
  usePostListMenuCache,
} from '@/composables/ui/postListMenu'
import useContextChangeVars from '@/composables/contextCahngeVars/contextChangeVars'
import { PostContentConstraints } from '@/validation/postValidator'

export default defineComponent({
  name: 'PostListMenu',
  emits: ['change-strategy'],
  components: { AButton },
  props: {
    currentStrategy: {
      type: Number,
    },
  },
  data() {
    return {
      selectMenuValue: null,
      NEWEST: ActivePostPage.Newest,
      OLDEST: ActivePostPage.Oldest,
      BEST: ActivePostPage.Best,
    }
  },
  methods: {},
  setup() {
    const menuRef: Ref<Node | undefined> = ref()
    const { windowActive, toggleWindow } = useClickOutside(menuRef)
    const { activePage } = usePostListMenu()
    const { updateDefaultPostListMenuCache } = usePostListMenuCache()
    const { contextChange } = useContextChangeVars()

    const emitNewestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Newest
      updateDefaultPostListMenuCache()
      contextChange()
    }
    const emitOldestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Oldest
      updateDefaultPostListMenuCache()
      contextChange()
    }
    const emitBestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Best
      updateDefaultPostListMenuCache()
      contextChange()
    }

    const onChange = (selectMenuValue: string | undefined) => {
      if (selectMenuValue === ActivePostPage.Newest) {
        emitNewestStrategy()
      } else if (selectMenuValue === ActivePostPage.Oldest) {
        emitOldestStrategy()
      } else if (selectMenuValue === ActivePostPage.Best) {
        emitBestStrategy()
      }
    }

    return {
      menuRef,
      windowActive,
      emitNewestStrategy,
      emitOldestStrategy,
      emitBestStrategy,
      toggleWindow,
      onChange,
      ...usePostListMenu(),
    }
  },
})
